"use strict";
const { ARRAY_CONTAINS, ARRAY_NOT_CONTAINS, } = require('../definitions/operators');
const negateExpression = require('./negateExpression');
module.exports = negateExpression(ARRAY_CONTAINS, ARRAY_NOT_CONTAINS);
//# sourceMappingURL=arrayNotContainsExpression.js.map